import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function LatestArticles() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新影视资讯
          </h2>
          <p className="text-sm text-foreground-600">
            追剧必备指南，最新影视动态一手掌握
          </p>
        </div>

        <div className="space-y-4">
          {articles.slice(0, 4).map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}